var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.ready
    ? _c(
        "div",
        {
          directives: [{ name: "style-sheet", rawName: "v-style-sheet" }],
          staticClass:
            "wrapper font-archivo relative text-brand-secondary overflow-x-hidden"
        },
        [
          _c("layout-header"),
          _vm.collections && _vm.collections.length
            ? _c("collections-menu")
            : _vm._e(),
          _c("main", { attrs: { id: "content" } }, [_c("router-view")], 1),
          _c("layout-footer", { ref: "footer" }),
          _c("vs-toaster", {
            attrs: { notifications: _vm.notifications },
            on: { "remove-toast": _vm.handleRemoveNotification }
          }),
          _vm.$route.name === "sales"
            ? _c("div", { staticClass: "csid" }, [
                _vm.campaign.products.length
                  ? _c("small", [_vm._v(_vm._s(_vm.campaign.analytics_cid))])
                  : _vm.campaignErrorInfo
                  ? _c("small", [
                      _vm._v(_vm._s(_vm.campaignErrorInfo.campaign_id))
                    ])
                  : _vm._e()
              ])
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }